import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FirmaComponent } from "app/features/componentes/firma";

interface Props {
    /**Id de la firma remota */
    id: string;
}
interface State {
    firma: models.FirmaUsuario;
}
export class FirmaRemota extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            firma: {
                IdRegistro: 0,
                Segmentos: []
            }
        };
    }

    id = (props: Props) => props.id;
    firmaRemota = createSelectorRx(this.id, id => observeResource(resources.FirmaRemota.Get, id));
    mensaje = createSelectorRx(this.firmaRemota, x => x.Mensaje);

    onGuardar = async () => {
        await resources.FirmaRemota.Update(this.props.id, this.state.firma);
        await kea.message("Firma capturada", undefined, "success");
    };

    render() {
        const props = this.props;
        const mensaje = this.mensaje(this.props);
        return (
            <div>
                <kea.Title titulo="Capturar firma" />
                <kea.Text value={mensaje} readonly={true} />
                <FirmaComponent value={this.state.firma} onChange={x => this.setState({ firma: x })} label="Firma" />
                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={this.onGuardar} disabled={this.state.firma.Segmentos.length == 0} />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/firmaremota/view.tsx